import React from 'react';
import {useNavigate} from 'react-router-dom';
import SettingsIcon from '@mui/icons-material/Settings';
import AgencyConfigurationsButtonProperties from "./AgencyConfigurationsButtonProperties";
import {useI18nContext} from "../../../contexts/I18nContext";
import Button from "../../../ui_components/Button/Button";
import ButtonType from "../../../ui_components/Button/ButtonType";
import ButtonSize from "../../../ui_components/Button/ButtonSize";

/** Opens the per-agency configuration page (documents and any future configuration tab). */
const AgencyConfigurationsButton: React.FC<AgencyConfigurationsButtonProperties> = ({
                                                                                       agencyId,
                                                                                       showIcon = true,
                                                                                       showText = true,
                                                                                       disabled,
                                                                                       className = '',
                                                                                       size = ButtonSize.DEFAULT,
                                                                                       type = ButtonType.DEFAULT
                                                                                   }) => {
    const i18n = useI18nContext();
    const navigate = useNavigate();

    const text = i18n.translate("AGENCY_CONFIGURATIONS");

    return <Button
        text={showText ? text : ""}
        className={className}
        tooltip={!showText ? text : ""}
        disabled={disabled}
        size={size}
        onClick={() => navigate(`/agency-configurations/${agencyId}`)}
        type={type}
        startIcon={showIcon ? <SettingsIcon/> : <></>}
    />
}

export default AgencyConfigurationsButton;
